var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#6F41D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.092 12.693C20.723 12.478 20.244 12.478 19.838 12.693L16.959 14.347L15.004 15.425L12.125 17.078C11.756 17.294 11.277 17.294 10.871 17.078L8.583 15.784C8.214 15.569 7.956 15.174 7.956 14.742V12.19C7.956 11.759 8.177 11.364 8.583 11.148L10.833 9.89C11.203 9.674 11.683 9.674 12.089 9.89L14.339 11.148C14.709 11.364 14.967 11.759 14.967 12.19V13.844L16.922 12.729V11.076C16.9242 10.8613 16.8667 10.6502 16.756 10.4662C16.6453 10.2823 16.4857 10.1326 16.295 10.034L12.125 7.662C11.756 7.446 11.277 7.446 10.871 7.662L6.627 10.034C6.43629 10.1326 6.27671 10.2823 6.16601 10.4662C6.05531 10.6502 5.99784 10.8613 6 11.076V15.856C6 16.288 6.221 16.683 6.627 16.899L10.871 19.271C11.24 19.486 11.72 19.486 12.125 19.271L15.004 17.653L16.959 16.539L19.838 14.922C20.207 14.706 20.686 14.706 21.092 14.922L23.343 16.18C23.713 16.395 23.97 16.79 23.97 17.222V19.774C23.97 20.205 23.75 20.6 23.343 20.816L21.093 22.11C20.723 22.326 20.243 22.326 19.838 22.11L17.587 20.852C17.217 20.636 16.959 20.241 16.959 19.81V18.156L15.004 19.271V20.924C15.004 21.355 15.225 21.751 15.631 21.966L19.875 24.338C20.244 24.554 20.723 24.554 21.129 24.338L25.373 21.966C25.742 21.751 26 21.356 26 20.924V16.144C26.0022 15.9293 25.9447 15.7182 25.834 15.5343C25.7233 15.3503 25.5637 15.2006 25.373 15.102L21.093 12.693H21.092Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon-icon.b718ed6832f14bb94b295e54e9f1cd3b.svg";
export { ForwardRef as ReactComponent };